export const colorsForEnergyEfficiency = {
  A: 'darkgreen',
  B: 'mediumgreen',
  C: 'lightgreen',
  D: 'yellow',
  E: 'lightorange',
  F: 'darkorange',
  G: 'red',
} as const;

export type ValidColor = (typeof colorsForEnergyEfficiency)[keyof typeof colorsForEnergyEfficiency];

export const isValidColor = (color: string): color is ValidColor =>
  Object.values(colorsForEnergyEfficiency).includes(color as ValidColor);

export type GetValidColorAndEfficiencyClassReturn =
  | {
      color: ValidColor;
      efficiencyClass: keyof typeof colorsForEnergyEfficiency;
    }
  | undefined;

export const getValidColorAndEfficiencyClass = (
  color: string,
): GetValidColorAndEfficiencyClassReturn => {
  switch (color) {
    case 'darkgreen': {
      return {
        color,
        efficiencyClass: 'A',
      };
    }
    case 'mediumgreen': {
      return {
        color,
        efficiencyClass: 'B',
      };
    }
    case 'lightgreen': {
      return {
        color,
        efficiencyClass: 'C',
      };
    }
    case 'yellow': {
      return {
        color,
        efficiencyClass: 'D',
      };
    }
    case 'lightorange': {
      return {
        color,
        efficiencyClass: 'E',
      };
    }
    case 'darkorange': {
      return {
        color,
        efficiencyClass: 'F',
      };
    }
    case 'red': {
      return {
        color,
        efficiencyClass: 'G',
      };
    }
    default: {
      return undefined;
    }
  }
};
